export default __webpack_public_path__ + "static/media/alte.075c0167.pdf";